import React, { useState, useEffect } from 'react'
import { ActivityIndicator, View, Text, Platform, FlatList } from 'react-native'
import { DataTable } from 'react-native-paper'
import CurrentlyNoItems from '../CurrentlyNoItems'
import OverlayHeader from '../OverlayHeader'
import { Overlay } from 'react-native-elements'
import { useDispatch } from 'react-redux'
import {
  listUserLogins,
  updateUserLogin
} from '../../store/admin/logins/actions'
import { cellStyle } from '../../screens/EntityListScreenHelpers/DataTableWrapper'
import MSFESInput from '../MSFESInput'
import spacing from '../../styles/spacing'
import { WrappedSwitch } from '../EntityField'
import MSFESButton from '../MSFESButton'
import { showMessage } from 'react-native-flash-message'
import _ from 'lodash'
export const LoginsUser = ({ activeSort, searchText }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [data, setData] = useState([])
  useEffect(() => {
    fetchNextPage()
  }, [page, searchText])

  useEffect(() => {
    setPage(1)
  }, [searchText])

  const fetchNextPage = () => {
    dispatch(listUserLogins({ page, searchText })).then((response) => {
      setLoading(false)
      if (page > 1) {
        setData((data) => [...data, ...response.data])
      } else {
        setData(response.data)
      }
      setPages(response.meta.last_page)
    })
  }

  const [editingUser, setEditingUser] = useState(null)

  const [dataSorted, setDataSorted] = useState([])
  useEffect(() => {
    setDataSorted(
      _.orderBy(
        data,
        [(i) => ('' + i).trim().toLowerCase()],
        [activeSort.name == 'a_to_z' ? 'asc' : 'desc']
      )
    )
  }, [data, data.length, activeSort])

  const saveChanges = () => {
    setSaving(true)
    dispatch(updateUserLogin({ user: editingUser }))
      .then((response) => {
        setEditingUser(false)
        showMessage({
          message: 'Updated.',
          type: 'success'
        })
        setData((data) => {
          const newData = [...data]
          const index = newData.findIndex((el) => el.id === response.data.id)
          newData[index] = response.data
          return newData
        })
      })
      .finally(() => {
        setSaving(false)
      })
  }

  return (
    <View style={{ flex: 1 }}>
      {loading && <ActivityIndicator />}
      {!loading && !data.length && <CurrentlyNoItems label="No users" />}

      {!!editingUser && (
        <Overlay
          isVisible={true}
          onBackdropPress={() => setEditingUser(false)}
          overlayStyle={{ padding: 0, margin: 0 }}
        >
          <View
            style={{
              flex: 1,
              padding: spacing.m1,
              minHeight: Platform.OS === 'ios' ? 330 : 140
            }}
          >
            <OverlayHeader>{editingUser.name}</OverlayHeader>

            <MSFESInput
              label={'User'}
              editable={false}
              horizontal
              defaultValue={editingUser.name}
            />
            <MSFESInput
              label={'Email'}
              editable={false}
              horizontal
              defaultValue={editingUser.email}
            />
            <MSFESInput
              label={'User can Sign In'}
              horizontal
              InputComponent={WrappedSwitch}
              onValueChange={() =>
                setEditingUser((editingUser) => ({
                  ...editingUser,
                  hasChanges: true,
                  signInEnabled: !editingUser.signInEnabled
                }))
              }
              value={editingUser.signInEnabled}
            />
            <MSFESInput
              label={'Error Message'}
              horizontal
              onChangeText={(signInDisabledError) => {
                setEditingUser((editingTenant) => ({
                  ...editingTenant,
                  hasChanges: true,
                  signInDisabledError
                }))
              }}
              editable={!editingUser.signInEnabled}
              placeholder={`Enter sign in failed error message`}
              defaultValue={editingUser.signInDisabledError}
            />
            <MSFESButton
              loading={saving}
              onPress={saveChanges}
              title="Save Sign-In Changes"
            />
          </View>
        </Overlay>
      )}
      {!loading && !!data.length && (
        <DataTable style={{ flex: 1 }}>
          <DataTable.Header>
            <DataTable.Title key={'user'}>User</DataTable.Title>
            <DataTable.Title key={'user'}>Email</DataTable.Title>
            <DataTable.Title key={'status'}>Status</DataTable.Title>
            <DataTable.Title key={'role'}>Role</DataTable.Title>
            <DataTable.Title key={'tenants'}>Tenant/s</DataTable.Title>
          </DataTable.Header>

          <View style={{ flex: 1 }}>
            <FlatList
              data={dataSorted}
              onEndReached={() => {
                if (page < pages) {
                  setPage(page + 1)
                }
              }}
              renderItem={({ item: user, index }) => {
                return (
                  <DataTable.Row
                    key={index}
                    style={{
                      backgroundColor: index % 2 ? 'transparent' : '#f1f1f1'
                    }}
                    onPress={() => setEditingUser(user)}
                  >
                    <DataTable.Cell key={'name'} style={cellStyle}>
                      <Text>{user.name}</Text>
                    </DataTable.Cell>

                    <DataTable.Cell key={'email'} style={cellStyle}>
                      <Text>{user.email}</Text>
                    </DataTable.Cell>
                    <DataTable.Cell key={'enabled'} style={cellStyle}>
                      <Text
                        style={{
                          fontWeight: !user.signInEnabled ? 'bold' : 'normal'
                        }}
                      >
                        {user.signInEnabled == true ? 'Enabled' : 'Disabled'}
                      </Text>
                    </DataTable.Cell>
                    <DataTable.Cell key={'roles'} style={cellStyle}>
                      <Text>{user.role.join(', ')}</Text>
                    </DataTable.Cell>
                    <DataTable.Cell key={'tenants'} style={cellStyle}>
                      <Text>{user.tenant?.join(', ')}</Text>
                    </DataTable.Cell>
                  </DataTable.Row>
                )
              }}
            />
          </View>
        </DataTable>
      )}
    </View>
  )
}
